<template>
  <div
    id="dashboard"
    class="row w-100 pl-5 justify-content-start"
    :style="{
      //backgroundImage: `url(${require('@/assets/img/page_bg.png')})`,
      paddingRight: '0px',
      margin: '0px',
      padding: '0px !important',
    }"
  >
    <div class="container-fluid">
      <div>
        <div class="row">
          <!-- <div class="h3">事件設定</div> -->
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-12 bd-callout bg-white">
            <div class="h5 mb-0 font-weight-bold text-primary">
              推播文字設定
            </div>
            <hr />
            <div class="row">
              <div class="col-12  table-scrollbar">
                <table :class="tableStyle">
                  <thead :class="tableThStyle" class="table-dark">
                    <tr>
                      <th scope="col" width="10%">景區</th>
                      <th v-for="(t, i) in CONST.INFORM_SETTING_WETHER_ITEM" :key="i"scope="col" >{{t.description}}</th>
                    </tr>
                  </thead>
                  <tbody :class="tableCenterStyle">
                    <tr v-for="(s, i) in weatherScenicArea" :key="i">
                      <td>{{s.name}}</td>
                      <td v-for="(t, i) in CONST.INFORM_SETTING_WETHER_ITEM" :key="i">
                        {{getDisasterFromAreaAndType(s.id,t.enumType)?getDisasterFromAreaAndType(s.id,t.enumType).magnitudeValue:''}}
                        <button
                          class="btn btn-primary bg-indigo"
                          data-toggle="modal"
                          @click="openModal(s, t)"
                          v-if="(getDisasterFromAreaAndType(s.id,t.enumType)?true:false)"
                        >
                          編輯
                        </button>
                      </td>
                    </tr>
                    
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <!-- <div class="col-sm-12 col-md-12 bd-callout bg-white">
            <div class="h5 mb-0 font-weight-bold text-primary text-uppercase">
              違規闖入
            </div>
            <hr />
            <div class="row">
              <div class="col-12"></div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    
    <!-- 石梯坪陣風 Modal -->
    <div class="modal fade" ref="disasterSetting">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title h5">{{selectScienicArea? selectScienicArea.name : ""}} {{selectDisasterType? selectDisasterType.description : ""}}通報設定</div>
          </div>
          <div class="modal-body">
            <div class="row" v-for="(d, i ) in selectDisasters" :key="i">
              <div class="form-group h6 col-3" v-if="!isNaN(d.magnitudeValue)">
                <label>{{selectDisasterType? selectDisasterType.unitTitle : ""}}</label>
                <input type="text" class="form-control" v-model="d.magnitudeValue" />
              </div>
              <div class="form-group h6 col-9" v-if="!isNaN(d.magnitudeValue)">
                <label>通報內容</label>
                <textarea class="form-control" rows="3" v-model="d.content">
                </textarea>
              </div>

              <div class="form-group form-check h6 col-3 pl-5" v-if="isNaN(d.magnitudeValue)">
                <label class="form-check-label" style="color: #41757e; font-weight: bold;">
                  {{d.magnitudeValue}}
                </label>
              </div>
              <div class="form-group h6 col-9" v-if="isNaN(d.magnitudeValue)">
                <label>通報內容</label>
                <textarea class="form-control" rows="3" v-model="d.content">
                </textarea>
              </div>
            </div>    
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              @click="closeModal"
            >
              取消
            </button>
            <button type="button" class="btn btn-primary" @click="updateDisasters">儲存</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import {mapState, mapGetters} from 'vuex'
import CONST from '../../utils/const'
import Utils from '../../utils/utils'

export default {
  data() {
    return {
      CONST: CONST,
      Utils: Utils,
      tableStyle: "table table-bordered table-hover h6",
      tableThStyle: "bg-info text-white text-center",
      tableCenterStyle: "text-center",
      selectScienicArea: null,
      selectDisasterType: null,
      selectDisasters: null,
    };
  },
  computed:{
    ...mapState('disasterSettingDBModal', {disasters: 'disasters'}),

    ...mapGetters('scenicArea', {weatherScenicArea: 'getWetherScienicArea'}),
  },
  watch: {
  },
  methods: {
    setSelectedDisaster() {
      const disasters =  this.disasters.filter(d => d.scenicAreaId === this.selectScienicArea.id && d.conditionType === this.selectDisasterType.enumType)
      const selectDisasters = disasters.sort((a,b) => a.magnitudeValue - b.magnitudeValue)
      this.selectDisasters = JSON.parse(JSON.stringify(selectDisasters))
    },
    getDisasterFromAreaAndType(areaid,type,index) {
      const disasters =  this.disasters.filter(d => d.scenicAreaId === areaid && d.conditionType ===type)
      if(!index) index=0
      const selectDisasters = disasters.sort((a,b) => a.magnitudeValue - b.magnitudeValue)[index]
      //debugger
      if(!selectDisasters) return null
      return JSON.parse(JSON.stringify(selectDisasters))
    },
    openModal(scienicArea, type) {
      this.selectScienicArea = scienicArea
      this.selectDisasterType = type
      this.setSelectedDisaster()
      $(this.$refs.disasterSetting).modal('show');
    },
    closeModal() {
      $(this.$refs.disasterSetting).modal('hide')
    },
    async updateDisasters() {
      const result = await this.$store.dispatch('disasterSettingDBModal/putDisasters', this.selectDisasters)

      if(result.success) {
        this.closeModal()
        console.log(this.selectDisasters)
      } else {
        alert('編輯失敗')
      }
    },
  },
  mounted() {
    
  }
};
</script>

<style>
.table-scrollbar{
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch; 

}

.table-scrollbar::-webkit-scrollbar{
  height: 10px;
}

.table-scrollbar::-webkit-scrollbar-track {

    border-radius: 8px;
    -webkit-border-radius: 8px;
}
 
.table-scrollbar::-webkit-scrollbar-thumb {
    -webkit-border-radius: 10px;
    border-radius: 10px;
    background: rgba(100,100,100,0.8); 

}

</style>